import { gmiRequest } from 'actions/request';
import actions from '@ehi/global-marketing-interface/lib/actions';

export const modifyReservationStart =
  ({ redirect = true } = {}) =>
  (dispatch) =>
    dispatch(
      gmiRequest({
        action: actions.reservations.modifyStart(),
        loadingOverlay: true,
        redirect,
      })
    );
